import { forwardRef } from "react";
import styled from "styled-components";
import { ArrowRightIcon } from "lucide-react";

const LinkedObjectLabel = styled(
  forwardRef(
    (
      {
        className,
        object_type,
        object_name,
        position,
        style = {},
        interactive,
        color: _color,
        ...rest
      },
      ref
    ) => {
      return (
        <div
          ref={ref}
          className={className}
          style={style}
          data-interactive={interactive ? "true" : undefined}
          tabIndex={interactive ? 0 : undefined}
          role={interactive ? "button" : undefined}
          {...rest}
        >
          {object_type && <div className="object-type">{object_type}</div>}
          <div className="object-name">{object_name}</div>
          {interactive && (
            <ArrowRightIcon size={12} className="arrow-icon" aria-hidden />
          )}
        </div>
      );
    }
  )
)`
  user-select: none;
  position: ${({ position }) => (position ? "absolute" : "relative")};
  top: ${({ position }) => (position?.includes("top") ? "10px" : "auto")};
  right: ${({ position }) => (position?.includes("right") ? "10px" : "auto")};
  bottom: ${({ position }) => (position?.includes("bottom") ? "10px" : "auto")};
  left: ${({ position }) => (position?.includes("left") ? "10px" : "auto")};

  display: flex;
  align-items: center;

  &[data-interactive="true"] {
    cursor: pointer;
    min-width: 0;
    width: fit-content;
    justify-self: start;
    .object-name {
      max-width: 280px;
      min-width: 0;
      padding: 1px 6px;
      border-radius: 3px;
      background-color: ${({ theme }) => theme.palette.background.secondary};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .arrow-icon {
      visibility: hidden;
      flex-shrink: 0;
      margin-left: 4px;
      color: ${({ theme }) => theme.palette.text.secondary};
    }
    &:hover,
    &:focus-visible {
      .arrow-icon {
        visibility: visible;
      }
      .object-name {
        background-image: linear-gradient(
            ${({ theme }) => theme.palette.action.hover},
            ${({ theme }) => theme.palette.action.hover}
          ),
          linear-gradient(
            ${({ theme }) => theme.palette.action.hover},
            ${({ theme }) => theme.palette.action.hover}
          );
      }
    }
    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.palette.primary.main};
      outline-offset: 1px;
      border-radius: 3px;
    }
  }

  .object-name {
    margin-left: 5px;
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .object-type {
    width: fit-content;
    padding: 1px 3px;
    border-radius: 3px;
    font-size: 10px;
    font-weight: 600;
    text-transform: capitalize;
    background-color: ${({ color, theme }) =>
      color === "success"
        ? `${theme.palette.success.main}35`
        : color === "error"
        ? `${theme.palette.error.main}35`
        : color === "warning"
        ? `${theme.palette.warning.main}35`
        : color === "info"
        ? `${theme.palette.info.main}35`
        : color === "primary"
        ? `${theme.palette.primary.main}35`
        : theme.palette.background.secondary};

    color: ${({ color, theme }) =>
      color === "success"
        ? theme.palette.success.main
        : color === "error"
        ? theme.palette.error.main
        : color === "warning"
        ? theme.palette.warning.main
        : color === "info"
        ? theme.palette.info.main
        : color === "primary"
        ? theme.palette.primary.main
        : theme.palette.text.secondary};
  }
`;

export default LinkedObjectLabel;
